import React, { useState } from 'react';
import DressCard from '../Categories/DressCard';
import DressDetailView from '../Categories/DressDetailView';
import useDraftImageUrls from './useDraftImageUrls';
import { categoryImageUrl } from '../data/categoryImageUrl';
import { GOLD_LT, INK } from '../theme';

export default function DressPreviewPane({ category, dress }) {
  const [view, setView] = useState('detail');
  const previewImageUrl = useDraftImageUrls(dress.images, categoryImageUrl);

  const tabStyle = (active) => ({
    fontSize: 12,
    letterSpacing: '.12em',
    textTransform: 'uppercase',
    color: active ? INK : GOLD_LT,
    background: active ? GOLD_LT : 'none',
    border: `1px solid ${GOLD_LT}`,
    padding: '8px 14px',
    cursor: 'pointer',
  });

  return (
    <div style={{ border: '1px solid rgba(201,162,75,.3)', position: 'sticky', top: 20 }}>
      <div style={{ display: 'flex', gap: 8, padding: 12, borderBottom: '1px solid rgba(201,162,75,.3)' }}>
        <button onClick={() => setView('card')} style={tabStyle(view === 'card')}>Listing card</button>
        <button onClick={() => setView('detail')} style={tabStyle(view === 'detail')}>Dress detail page</button>
      </div>
      <div style={{ maxHeight: 700, overflow: 'auto', padding: view === 'card' ? 24 : 0 }}>
        {view === 'card' ? (
          <div style={{ maxWidth: 280 }}>
            <DressCard dress={dress} categorySlug={category.slug} imageUrl={previewImageUrl} onQuickView={() => {}} />
          </div>
        ) : (
          <DressDetailView category={category} dress={dress} prevDress={null} nextDress={null} others={[]} imageUrl={previewImageUrl} />
        )}
      </div>
    </div>
  );
}
